import React from 'react';
import Circle from '~/icons/CountdownCircle';
import { FinanceCardType, FinanceStatus } from './constants';
import StatusIndicator from '../StatusIndicator';

const maxSoftPullLength = 30;

function Countdown({ daysToExpired }: { daysToExpired: number }) {
  const days = daysToExpired < 0 ? 0 : daysToExpired;

  return (
    <div
      className="flex items-center justify-center"
      data-qa="count-down-expiration"
    >
      <div className="relative flex self-start">
        <Circle
          className="h-[60px] w-[60px]"
          ratio={days / maxSoftPullLength}
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <p className="pt-4 text-blue-6 tl-header-m" data-qa="countdown-days">
            {days}
          </p>
          <p
            className="relative -top-4 text-blue-6 tl-body-s"
            data-qa="countdown-text"
          >
            day{days === 1 ? '' : 's'}
          </p>
        </div>
      </div>
    </div>
  );
}

type OwnProps = React.PropsWithChildren<{
  cta: React.ReactNode;
  daysToExpired: number;
  status: FinanceCardType;
  title: string;
}>;

export default function FinanceCard({
  cta,
  daysToExpired,
  status,
  title
}: OwnProps) {
  const isExpired = status === FinanceCardType.Expired;

  return (
    <div className="flex flex-col gap-16" data-qa="finance-card-pre-qualified">
      <div className="flex flex-row justify-between">
        <h3 className="text-blue-6 tl-header-m">{title}</h3>
        <StatusIndicator
          status={isExpired ? FinanceStatus.Expired : FinanceStatus.Active}
          text={isExpired ? 'Expired' : 'Pre-qualified'}
        />
      </div>

      <div className="flex flex-row">
        <Countdown daysToExpired={daysToExpired} />

        <div className="pl-16">
          <p className="text-blue-6 tl-header-s">
            {isExpired
              ? 'Refresh to get instantly pre-qualified.'
              : 'You are pre-qualified'}
          </p>
          <p className="text-blue-6 tl-body-m">
            {isExpired
              ? 'No hit to your credit'
              : 'See real monthly payments on every vehicle.'}
          </p>
        </div>
      </div>

      {cta}
    </div>
  );
}
